import {getCookie, setCookie} from '@vio/core/src/_web/utils/cookies'

const MAX_MESSAGES_PER_DAY = 150
const CHATBOT_MESSAGES_COUNT = 'chatbotMessagesCount'

const getMessageCount = () =>
  parseInt(getCookie(CHATBOT_MESSAGES_COUNT) || '0', 10)

export const incrementMessageCount = () => {
  const count = getMessageCount() + 1
  setCookie(CHATBOT_MESSAGES_COUNT, count.toString(), {
    expires: 1 // 1 day
  })
}

export const hasReachedDailyMessageLimit = () => {
  return getMessageCount() >= MAX_MESSAGES_PER_DAY
}
